import React, { useState, useEffect, useRef } from 'react';
import ReactQuill, { Quill } from 'react-quill';
import tutorial from './tutorial';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExport, faFileImport } from '@fortawesome/free-solid-svg-icons';
import 'react-quill/dist/quill.snow.css'; // Ensure this is imported
import { faListUl, faListOl } from '@fortawesome/free-solid-svg-icons';



// Define custom buttons for import/export if not already defined
const CustomButton = () => <FontAwesomeIcon icon={faFileExport} />;
const CustomImportButton = () => <FontAwesomeIcon icon={faFileImport} />;

// Register custom buttons with Quill
Quill.register('modules/customButton', CustomButton);
Quill.register('modules/customImportButton', CustomImportButton);


const TextEditor = ({ onChange }) => {
    const [text, setText] = useState(tutorial());
    const [debouncedText, setDebouncedText] = useState('');
    const quillRef = useRef(null);
    const exportText = () => {
        const element = document.createElement("a");
        const file = new Blob([text], {type: 'text/plain'});
        element.href = URL.createObjectURL(file);
        element.download = "file.mtex";
        document.body.appendChild(element); // Required for this to work in FireFox
        element.click();
    };

    const importText = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                setText(e.target.result); // Assuming setText sets the text editor's content
            };
            reader.readAsText(file);

            // Reset the value of the file input to ensure onChange fires for the same file
            event.target.value = '';
        }
    };

    // Implement debouncing
    useEffect(() => {
        // Set up a timer to run onChange after a delay
        const handler = setTimeout(() => {
            setDebouncedText(text);
        }, 500); // 500 milliseconds debounce period

        // Cleanup function to cancel the timeout if text changes again
        return () => {
            clearTimeout(handler);
        };
    }, [text]);

    // Trigger the external onChange when the debounced text changes
    useEffect(() => {
        if (debouncedText) {
            onChange(debouncedText);
        }
    }, [debouncedText, onChange]);

    return (
        <div>
            <div id="toolbar">
                {/* Quill's standard buttons */}
                <select className="ql-header">
                    <option value="1">Heading 1</option>
                    <option value="2">Heading 2</option>
                    <option value="3">Heading 3</option>
                    <option selected></option>
                </select>
                <button className="ql-bold"></button>
                <button className="ql-italic"></button>
                <button className="ql-underline"></button>
                <button className="ql-link"></button>
                <button className="ql-list" value="bullet" title="Bullet List">
                    <FontAwesomeIcon icon={faListUl} /> {/* Assuming you're using FontAwesome */}
                </button>
                <button className="ql-list" value="ordered" title="Numbered List">
                    <FontAwesomeIcon icon={faListOl} /> {/* FontAwesome icon */}
                </button>
                <button className="ql-clean"></button>

                {/* Custom buttons for Import/Export */}

                <button className="custom-button" onClick={() => document.querySelector('input[type=file]').click()} title="Import">
                    <FontAwesomeIcon icon={faFileImport} />
                </button>
                <input
                    type="file"
                    style={{ display: 'none' }}
                    onChange={importText}
                    accept=".mtex,.md,.txt"/>
                <button className="custom-button" onClick={exportText} title="Export">
                    <FontAwesomeIcon icon={faFileExport} />
                </button>

            </div>
            <ReactQuill
                ref={quillRef}
                value={text}
                onChange={setText}
                modules={{ toolbar: '#toolbar' }} // Link custom toolbar
            />
        </div>
    );
};

export default TextEditor;